module.exports = __webpack_public_path__ + "img/restore_button.6949ab35.svg";